"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Brainstorm = function Brainstorm(_ref) {
  var borderColor = _ref.borderColor,
      offsetColor = _ref.offsetColor;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, _react.default.createElement("g", {
    fill: offsetColor
  }, _react.default.createElement("ellipse", {
    cx: "88",
    cy: "383.99",
    rx: "40",
    ry: "48"
  }), _react.default.createElement("ellipse", {
    cx: "264",
    cy: "383.99",
    rx: "40",
    ry: "48"
  }), _react.default.createElement("ellipse", {
    cx: "440",
    cy: "383.99",
    rx: "40",
    ry: "48"
  }), _react.default.createElement("path", {
    d: "M232 206.4V248a16 16 0 0016 16h48a16 16 0 0016-16v-41.6a88.04 88.04 0 0046.92-92.4c-5.92-38.56-38-69.12-76.78-73.44A87.98 87.98 0 00184 128a87.96 87.96 0 0048 78.4z"
  })), _react.default.createElement("g", {
    fill: borderColor
  }, _react.default.createElement("path", {
    d: "M80 416c-26.47 0-48-25.13-48-56s21.53-56 48-56 48 25.11 48 56-21.53 56-48 56zm0-96c-17.65 0-32 17.94-32 40s14.35 40 32 40 32-17.95 32-40-14.35-40-32-40zM40 512a8 8 0 01-8-8v-24a8 8 0 0116 0v24a8 8 0 01-8 8zm80 0a8 8 0 01-8-8v-24a8 8 0 0116 0v24a8 8 0 01-8 8z"
  }), _react.default.createElement("path", {
    d: "M8 512a8 8 0 01-8-8v-64c0-13.24 10.77-24 24-24h24c4.4 0 8-3.6 8-8v-4a8 8 0 0116 0v4c0 13.22-10.77 24-24 24H24c-4.4 0-8 3.58-8 8v64a8 8 0 01-8 8zm144 0a8 8 0 01-8-8v-64c0-4.42-3.6-8-8-8h-24c-13.23 0-24-10.78-24-24v-4a8 8 0 0116 0v4c0 4.4 3.6 8 8 8h24c13.23 0 24 10.76 24 24v64a8 8 0 01-8 8zm104-96c-26.47 0-48-25.13-48-56s21.53-56 48-56 48 25.11 48 56-21.53 56-48 56zm0-96c-17.65 0-32 17.94-32 40s14.35 40 32 40 32-17.95 32-40-14.35-40-32-40zm-40 192a8 8 0 01-8-8v-24a8 8 0 0116 0v24a8 8 0 01-8 8zm80 0a8 8 0 01-8-8v-24a8 8 0 0116 0v24a8 8 0 01-8 8z"
  }), _react.default.createElement("path", {
    d: "M184 512a8 8 0 01-8-8v-64c0-13.24 10.77-24 24-24h24c4.4 0 8-3.6 8-8v-4a8 8 0 0116 0v4c0 13.22-10.77 24-24 24h-24c-4.4 0-8 3.58-8 8v64a8 8 0 01-8 8zm144 0a8 8 0 01-8-8v-64c0-4.42-3.6-8-8-8h-24c-13.23 0-24-10.78-24-24v-4a8 8 0 0116 0v4c0 4.4 3.6 8 8 8h24c13.23 0 24 10.76 24 24v64a8 8 0 01-8 8zm104-96c-26.47 0-48-25.13-48-56s21.53-56 48-56 48 25.11 48 56-21.53 56-48 56zm0-96c-17.65 0-32 17.94-32 40s14.35 40 32 40 32-17.95 32-40-14.35-40-32-40zm-40 192a8 8 0 01-8-8v-24a8 8 0 0116 0v24a8 8 0 01-8 8zm80 0a8 8 0 01-8-8v-24a8 8 0 0116 0v24a8 8 0 01-8 8z"
  }), _react.default.createElement("path", {
    d: "M360 512a8 8 0 01-8-8v-64c0-13.24 10.77-24 24-24h24c4.4 0 8-3.6 8-8v-4a8 8 0 0116 0v4c0 13.22-10.77 24-24 24h-24c-4.4 0-8 3.58-8 8v64a8 8 0 01-8 8zm144 0a8 8 0 01-8-8v-64c0-4.42-3.6-8-8-8h-24c-13.23 0-24-10.78-24-24v-4a8 8 0 0116 0v4c0 4.4 3.6 8 8 8h24c13.23 0 24 10.76 24 24v64a8 8 0 01-8 8zM280 240h-48c-13.23 0-24-10.78-24-24v-36.86A95.61 95.61 0 01160 96a96.16 96.16 0 0132-71.57A96.53 96.53 0 01267.02.6c42.15 4.7 77.4 38.42 83.8 80.18 6.1 39.7-12.62 78.59-46.83 98.35V216c0 13.23-10.77 24-24 24zM255.9 15.98a79.13 79.13 0 00-53.24 20.35A80.17 80.17 0 00176 95.99a79.72 79.72 0 0043.64 71.28 8 8 0 014.36 7.12V216c0 4.41 3.6 8 8 8h48c4.4 0 8-3.59 8-8v-41.6a8 8 0 014.36-7.13c30.82-15.75 47.96-49.52 42.66-84.04-5.33-34.74-34.67-62.8-69.76-66.7a84.21 84.21 0 00-9.36-.54zM432 296a8 8 0 01-8-8v-16H88v16a8 8 0 01-16 0v-24a8 8 0 018-8h352a8 8 0 018 8v24a8 8 0 01-8 8z"
  }), _react.default.createElement("path", {
    d: "M256 296a8 8 0 01-8-8V152a8 8 0 0116 0v136a8 8 0 01-8 8z"
  }), _react.default.createElement("path", {
    d: "M256 160a8.01 8.01 0 01-6.66-3.57l-32-48A7.99 7.99 0 01224 96h64a8 8 0 016.66 12.43l-32 48A8.01 8.01 0 01256 160zm-17.05-48L256 137.56l17.05-25.58h-34.1zM136 104h-32a8 8 0 010-16h32a8 8 0 010 16zm0-40a7.8 7.8 0 01-1.94-.25l-32-8a8 8 0 013.88-15.52l32 8A8 8 0 01136 63.98zm-32 88a8 8 0 01-1.94-15.77l32-8a8.01 8.01 0 013.88 15.53l-32 8c-.65.16-1.3.23-1.95.23zm304-48h-32a8 8 0 010-16h32a8 8 0 010 16zm-32-40a8 8 0 01-1.94-15.77l32-8a8.01 8.01 0 013.88 15.53l-32 8c-.65.16-1.3.23-1.95.23zm32 88a7.8 7.8 0 01-1.94-.25l-32-8a8 8 0 013.88-15.53l32 8A8 8 0 01408 152z"
  })));
};

Brainstorm.propTypes = {
  borderColor: _propTypes.default.string,
  offsetColor: _propTypes.default.string
};
Brainstorm.defaultProps = {
  borderColor: "#242523",
  offsetColor: "#63DC3E"
};
var _default = Brainstorm;
exports.default = _default;